import { css } from '@inter-ikea-kompis/web-component';

import VerticalAlignmentEnum from '../../enums/VerticalAlignmentEnum.js';

type StyleOptions = {
	mixedSize: boolean;
	strikeThrough: boolean;
	decimalVerticalAlignment: string;
	currencyVerticalAlignment: string;
};

export default class PriceFormatterStyle {
	/**
	 * Returns styles.
	 *
	 * @param options ...
	 */
	public static getStyle(options: StyleOptions): string {
		return css`
			${this.getMixedSizeStyle(options) ?? ''}
			.currencySpacing {
				width: ${options.mixedSize ? '0.12em' : '0.06em'};
			}
			.price {
				display: flex;
				text-decoration: ${options.strikeThrough ? 'line-through' : 'initial'};
			}
			.visuallyHidden:not(:focus):not(:active) {
				clip: rect(0 0 0 0);
				clip-path: inset(50%);
				height: ${1 / 16}rem;
				overflow: hidden;
				position: absolute;
				white-space: nowrap;
				width: ${1 / 16}rem;
			}
		`;
	}

	private static getMixedSizeStyle(options: StyleOptions): string | null {
		if (!options.mixedSize) {
			return null;
		}
		return css`
			.currency,
			.spacing,
			.decimalPart {
				position: relative;
				font-size: 0.6em;
			}
			.currency {
				bottom: ${options.currencyVerticalAlignment === VerticalAlignmentEnum.super
					? '0.2em'
					: '-0.26em'};
			}
			.decimalPart {
				bottom: ${options.decimalVerticalAlignment === VerticalAlignmentEnum.super
					? '0.2em'
					: '-0.26em'};
			}
		`;
	}
}
